<template>
  <div>
    <v-layout row>
        <v-flex xs2>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs3 justify-center>
          <h3>BILL OF LADINGS</h3><h4>{{ client.CLIENTNAME }}</h4>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex xs2>
          <v-btn color="primary" @click="createBOL">NEW BILL OF LADING</v-btn>
        </v-flex>
    </v-layout>
    <br>
    <v-data-table
        :headers='headers'
        :items='bols'
        hide-actions
        class="elevation-1"
        >
        <template slot="items" slot-scope="props">
          <tr>
            <td width=150px @click="rowClicked(props.item)">{{ formattedDate(props.item) }}</td>
            <td width=150px @click="rowClicked(props.item)">{{ props.item.id }}</td>
            <td width=150px @click="rowClicked(props.item)">{{ props.item.direction }}</td>
            <td width=150px @click="rowClicked(props.item)">{{ props.item.bonded }}</td>
            <td @click="rowClicked(props.item)">{{ props.item.Location.name }}</td>
          </tr>
        </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import myMixins from '../mixins/myMixins'
import moment from 'moment'
export default {
  data () {
    return {
      bols: [],
      headers: [
        { text: 'Date', value: 'date', sortable: 'false' },
        { text: 'Number', value: 'id', sortable: 'false' },
        { text: 'Direction', value: 'direction', sortable: 'true' },
        { text: 'Tax Status', value: 'bonded', sortable: 'true' },
        { text: 'Name', value: 'Location.name', sortable: 'true' }
      ]
    }
  },
  mixins: [myMixins],
  watch: {
    clientcode: function (nv, ov) {
      this.retrieveBOLs(this.clientcode, this.vintage)
    },
    vintage: function (nv, ov) {
      this.retrieveBOLs(this.clientcode, this.vintage)
    }
  },
  created () {
    this.retrieveBOLs(this.clientcode, this.vintage)
  },
  computed: {
    lots () {
      return this.$store.state.lotsForVintage
    },
    vintage () {
      return this.$store.state.vintage
    },
    clientcode () {
      return this.$store.state.client.CODE
    },
    client () {
      return this.$store.state.client
    }
  },
  methods: {
    formattedDate (item) {
      return moment(item.date).format('L')
    },
    createBOL () {
      this.$router.push({ path: '/bols/-1' })
    },
    retrieveBOLs (clientcode, vintage) {
      axios
        .get(process.env.VUE_APP_BACKEND+'billOfLadings?clientcode='+clientcode)
        .then((response) => {
          this.bols = response.data.data
        })
    },
    rowClicked (item) {
      let theID = item.id
      this.$router.push({ path: `/bols/${theID}` })
    }
  }
}
</script>
<style>
</style>
